import React from "react";
import { adjust, remove, assoc } from "ramda";
import { Grid, IconButton } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import FormSelectField from "commons/components/FormSelectField";
import FormTextField from "commons/components/FormTextField";
import CardSection from "commons/components/CardSection";
import {
  prepareDiscount,
  prepareCommission,
  prepareTax,
} from "commons/pages/sales/utils/initializers";

const getExtrasProps = (name) => {
  switch (name) {
    case "discounts":
      return {
        key: "discount_id",
        prepare: prepareDiscount,
        single: "discount",
      };
    case "commissions":
      return {
        key: "employee_id",
        prepare: prepareCommission,
        single: "commission",
      };
    default:
      return {
        key: "tax_id",
        prepare: prepareTax,
        single: "tax",
      };
  }
};

export default function ExtrasCard({
  title,
  options = [],
  items = [],
  onChange,
  Wrapper = CardSection,
  canDoAction,
  commissionLabel = "name",
}) {
  const { key, prepare, single } = getExtrasProps(title);

  const onItemSelect = (id) => {
    const exists = items.find((item) => item[key] === id);
    const item = options.find((item) => item.id === id);

    if (!exists && item) {
      onChange([...items, prepare(item)]);
    }
  };

  const onItemValueChange = (index, field) => (value) => {
    onChange(adjust(index, assoc(field, value), items));
  };
  const onRemove = (index) => {
    onChange(remove(index, 1, items));
  };

  return (
    <Wrapper>
      <Grid container spacing={1}>
        <FormSelectField
          label={title}
          value={null}
          options={options}
          optionLabel={commissionLabel}
          onChange={onItemSelect}
          disabled={!canDoAction(`add-${single}-line`)}
        />
      </Grid>
      {items.map((item, index) => (
        <Grid container spacing={1} key={item[key]} alignItems="center">
          <Grid item xs>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={4}>
                {item.name}
              </Grid>
              <FormTextField
                grid={4}
                size="small"
                margin="dense"
                value={item.value}
                onChange={onItemValueChange(index, "value")}
                disabled={!canDoAction(`edit-${single}-line`)}
              />
              <FormTextField
                grid={4}
                size="small"
                margin="dense"
                value={item.applied_value / 100}
                disabled
              />
            </Grid>
          </Grid>
          <Grid item xs="auto">
            <IconButton
              size="small"
              onClick={() => onRemove(index)}
              disabled={!canDoAction(`remove-${single}-line`)}
            >
              <Delete />
            </IconButton>
          </Grid>
        </Grid>
      ))}
    </Wrapper>
  );
}
